export const mbInByte: number = 1048576;

export const getFileSizeInMB = (fileItem?: File | null): number =>
	+((fileItem?.size || 0) / mbInByte).toFixed(2);